import apiService from "@/api/ApiService";

const POSTS_URL = "/mag-posts/";
const CATEGORY_URL = "/mag-category/";
const GENRES_URL = "/genres/";
const MULTIMEDIAS_URL = "/mag-multimedias/";
const TAGS_URL = "/mag-tags/";
const MAGROWITEMS_URL = "/mag-row-items/";

export class MagService {
  async getPosts() {
    return (await apiService.get(POSTS_URL)).data;
  }

  async getPost(id) {
    return (await apiService.get(`${POSTS_URL}${id}/`)).data;
  }

  async getPostFilter(params) {
    return (await apiService.get(POSTS_URL, { params })).data;
  }

  async getCategories() {
    return (await apiService.get(CATEGORY_URL)).data;
  }

  async getCategory(id) {
    return (await apiService.get(`${CATEGORY_URL}/${id}`)).data;
  }

  async getMultimedias() {
    return (await apiService.get(MULTIMEDIAS_URL)).data;
  }

  async getMultimedia(id) {
    return (await apiService.get(`${MULTIMEDIAS_URL}/${id}`)).data;
  }

  async getTags() {
    return (await apiService.get(TAGS_URL)).data;
  }

  async getTag(id) {
    return (await apiService.get(`${TAGS_URL}/${id}`)).data;
  }

  async getGenres() {
    return (await apiService.get(GENRES_URL)).data;
  }

  async getMagRowItemsParam(params) {
    return (await apiService.get(MAGROWITEMS_URL, { params })).data;
  }

  async getMagRowItems() {
    return (await apiService.get(MAGROWITEMS_URL)).data;
  }
}

const magService = new MagService();

export default magService;
